import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/inquiry',
  component: Layout,
  name: 'InquiryParent',
  meta: { title: 'inquire', root: true, auth: AUTH_KEYS.INQUIRY },
  children: [
    {
      path: '',
      name: 'Inquiry',
      component: () => import('@/views/Inquiry/Inquiry.vue'),
      meta: {
        title: 'inquire',
        isHide: true
      }
    }
  ]
};
